import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon, MapPinIcon, ShieldCheckIcon, MessageCircleIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { trackLead } from '../utils/metaPixel';
import { UpsellOption, getCheckoutUrl } from '../data/copy';
export function Hero({
  selectedUpsell
}: {
  selectedUpsell: UpsellOption;
}) {
  return <header className="relative isolate w-full overflow-hidden bg-abyss" data-id="element-61" data-mp="4jvxffn0vgyd">
      <img src="https://cdn.magicpatterns.com/patterns/generated-images/87dd5680-0bb1-4bcd-8cf4-38d1de0d17bf.jpg" alt="Pescador mexicano sosteniendo una lobina trofeo al amanecer en una presa" className="absolute inset-0 h-full w-full object-cover object-center opacity-55" data-id="element-62" data-mp="128pixfs3x15m" />
      <div className="absolute inset-0 bg-abyss/70" aria-hidden="true" data-id="element-63" data-mp="nbyir4alzley" />
      <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-abyss to-transparent" aria-hidden="true" data-id="element-64" data-mp="3d2bjxpolizvj" />

      <div className="relative mx-auto flex min-h-[62vh] max-w-6xl flex-col justify-end px-4 pb-8 pt-14 sm:min-h-[80vh] sm:px-8 sm:pb-20 sm:pt-24" data-id="element-65" data-mp="384s4img5wh20">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: [0.16, 1, 0.3, 1]
      }} data-id="element-66" data-mp="3o6khtotcoo8a">
          <div className="mb-3 flex flex-wrap items-center gap-x-3 gap-y-1 font-cond text-[0.68rem] uppercase tracking-[0.16em] text-chartreuse sm:mb-6 sm:text-sm sm:tracking-[0.2em]" data-id="element-67" data-mp="3e8wismopoukb">
            <span className="flex items-center gap-1.5" data-id="element-68" data-mp="358hmksa7lv21">
              <MapPinIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4" aria-hidden="true" data-id="element-69" data-mp="35a2fkdgvl5xs" />
              Hecho a mano en México
            </span>
            <span className="hidden h-4 w-px bg-bone/30 sm:block" aria-hidden="true" data-id="element-70" data-mp="2viomanfip2d3" />
            <span className="text-bone/70" data-id="element-71" data-mp="2hj5fbxyfzx2d">El Salto · Comedero · Aguamilpa</span>
          </div>

          <h1 className="font-display text-[1.9rem] uppercase leading-[0.95] text-bone sm:text-6xl sm:leading-[0.92] lg:text-[5rem]" data-id="element-72" data-mp="2hljas7x1bbag">
            La lobina de tu vida no está esperando
            <span className="block text-chartreuse" data-id="element-73" data-mp="s44ifoom7nif">
              otro pedazo de plástico muerto.
            </span>
          </h1>

          <p className="mt-4 max-w-2xl font-body text-[0.95rem] leading-relaxed text-bone/80 sm:mt-6 sm:text-xl" data-id="element-74" data-mp="ibozop5huuwh">
            Polímero de alta memoria para que la cola nunca deje de vibrar,
            aroma amasado dentro de la mezcla y colores moldeados a mano en
            México. Movimiento que se siente antes de verse.
          </p>

          <div className="mt-5 flex flex-col items-stretch gap-2.5 sm:mt-9 sm:flex-row sm:items-center sm:gap-4" data-id="element-75" data-mp="162capjapi0n9">
            <div className="flex flex-col gap-2" data-id="element-76" data-mp="110wr7vo6g26z">
              <CtaButton size="md" source="hero" href="#pack" itemName={selectedUpsell.title} value={selectedUpsell.price} className="sm:hidden" data-id="element-77" data-mp="x1w80c1sexjg">
                ¡Quiero pescar más ya! → ${selectedUpsell.price}
              </CtaButton>
              <CtaButton source="hero" href="#pack" itemName={selectedUpsell.title} value={selectedUpsell.price} className="hidden sm:inline-flex" data-id="element-78" data-mp="3hpsgzbzpc357">
                ¡Quiero pescar más ya! → ${selectedUpsell.price}
              </CtaButton>
              <a href="#garantia" className="flex items-center justify-center gap-1.5 font-cond text-xs uppercase tracking-wide text-chartreuse hover:underline sm:justify-start sm:text-sm" data-id="element-79" data-mp="269zfrlmtwjkp">
                <ShieldCheckIcon className="h-3.5 w-3.5" data-id="element-80" data-mp="2fyr8hvzpr7wo" />
                Dos salidas o te devolvemos ${selectedUpsell.price}
              </a>
            </div>
            
            <div className="flex flex-col gap-2 sm:ml-2" data-id="element-81" data-mp="2ozz4g7erbwnl">
              <span className="flex items-center justify-center gap-2 font-cond text-[0.8rem] uppercase tracking-wider text-bone/65 sm:justify-start sm:text-base" data-id="element-82" data-mp="2oye7yc8vu3n3">
                <FlameIcon className="h-4 w-4 text-blood sm:h-5 sm:w-5" aria-hidden="true" data-id="element-83" data-mp="unixt5i1ugi7" />
                120 packs por corrida y se acaban
              </span>
              <a href="https://wa.me/5212345678900" target="_blank" rel="noopener noreferrer" onClick={() => trackLead('hero-whatsapp')} className="flex items-center justify-center gap-1.5 font-cond text-xs uppercase tracking-wide text-bone/60 hover:text-bone sm:justify-start sm:text-sm" data-id="element-84" data-mp="4b461q1btyhv">
                <MessageCircleIcon className="h-3.5 w-3.5" data-id="element-85" data-mp="3hqa90oimaf0z" />
                Tengo dudas, pregúntame
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </header>;
}